module.exports = __webpack_public_path__ + "media/images/countrysquared/gn-8178516149b5b405717395741f35ec52.svg";